import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { dateReviverObject } from '../../utilities/date-reviver';

/**
 * HTTP Interceptor that automatically converts ISO date strings to Date objects
 * in all HTTP responses throughout the application
 */
export const dateInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    map((event) => {
      if (
        event instanceof HttpResponse &&
        event.body &&
        typeof event.body === 'object' &&
        !(event.body instanceof Blob) &&
        !(event.body instanceof ArrayBuffer)
      ) {
        return event.clone({ body: dateReviverObject(event.body) });
      }
      return event;
    }),
  );
};
